// Web shim for @react-native-community/datetimepicker using HTML input
import React from 'react';

function DateTimePicker({ value, mode, onChange, minimumDate, maximumDate, display, ...props }) {
  const inputType = mode === 'time' ? 'time' : 'date';

  const formatValue = (date) => {
    if (!date) return '';
    if (inputType === 'date') {
      return date.toISOString().split('T')[0];
    }
    return date.toTimeString().slice(0, 5);
  };

  const handleChange = (e) => {
    const val = e.target.value;
    if (!val) return;

    let newDate;
    if (inputType === 'date') {
      const [y, m, d] = val.split('-').map(Number);
      newDate = new Date(y, m - 1, d);
    } else {
      const [h, min] = val.split(':').map(Number);
      newDate = new Date(value || Date.now());
      newDate.setHours(h, min);
    }

    if (onChange) {
      onChange({ type: 'set', nativeEvent: { timestamp: newDate.getTime() } }, newDate);
    }
  };

  return (
    <input
      type={inputType}
      value={formatValue(value)}
      onChange={handleChange}
      min={minimumDate ? formatValue(minimumDate) : undefined}
      max={maximumDate ? formatValue(maximumDate) : undefined}
      style={{
        padding: 8,
        fontSize: 16,
        borderRadius: 4,
        border: '1px solid #ccc',
        fontFamily: 'inherit',
      }}
    />
  );
}

export default DateTimePicker;
